import { HTMLProps, forwardRef } from 'react';

import classNames from 'classnames';

import { useSectionContext } from './SectionContext';

import styles from './SectionActions.module.css';

export interface SectionActionsProps extends HTMLProps<HTMLDivElement> {
  force?: boolean;
}

const SectionActions = forwardRef<HTMLDivElement, SectionActionsProps>(
  (props, ref) => {
    const { force, className, children, ...rest } = props;
    const { expanded } = useSectionContext();

    const showContent = force || expanded;

    return (
      <div
        ref={ref}
        className={classNames(className, styles.root, {
          [styles.hidden]: !showContent,
        })}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

SectionActions.displayName = 'Section.Actions';

export default SectionActions;
